import { isGuestRoute } from "../constants";
import {
  handleReferralFromRoute,
  flushReferralQueueAfterLogin,
} from "@/utils/referralsTracker";

export function applyGlobalGuards(router, { store, isProtectedRoute }) {
  router.beforeEach(async (to, from, next) => {
    try {
      await handleReferralFromRoute({ store, route: to, onlyQueue: true });
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[referral] beforeEach error:", e);
      }
    }

    const isResetPassPage =
      to.path.startsWith("/auth/pass") || to.path.startsWith("/auth/reset");

    if (!isResetPassPage && !store.state.authChecked) {
      try {
        await store.dispatch("loginUserByToken");
      } catch (e) {
        // não logado, ok
      }
    }

    const isLogged = Boolean(store.state.user?.id);
    if (isLogged && isGuestRoute(to)) {
      return next("/dashboard");
    }

    return next();
  });

  router.beforeResolve(async (to, from, next) => {
    try {
      let isLogged = Boolean(store?.state?.user?.id);
      const protectedRoute = isProtectedRoute(to);

      if (!isLogged && protectedRoute && !store.state.authChecked) {
        try {
          await store.dispatch("loginUserByToken");
          isLogged = Boolean(store?.state?.user?.id);
        } catch (e) {
          // não logado -> segue
        }
      }

      if (isLogged) {
        await flushReferralQueueAfterLogin();
      }
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[referral] beforeResolve error:", e);
      }
    }

    next();
  });
}
